"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPI = void 0;
const axios_1 = __importDefault(require("axios"));
const httpClient = axios_1.default.create();
class BaseAPI {
    constructor(url, retry = { attempts: 0, delay: 1000 }) {
        this.url = url;
        this.retry = retry;
        this.sleep = (delay) => new Promise(resolve => {
            setTimeout(resolve, delay);
        });
    }
    request(method, path, params = null, axiosRequestConfig = {}, retryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const retry = retryParams !== null && retryParams !== void 0 ? retryParams : this.retry;
            let options = Object.assign(Object.assign({}, axiosRequestConfig), { method, url: this.getUrl(path) });
            if (params) {
                if ((method === null || method === void 0 ? void 0 : method.toLowerCase()) === 'get') {
                    options.params = params;
                }
                else {
                    options.data = params;
                }
            }
            let attempts = 0;
            while (true) {
                try {
                    const axiosResponse = yield httpClient.request(options);
                    const { ok, data, error } = this.parseResponse(axiosResponse);
                    return !ok || error ? Promise.reject({ message: error, data }) : data;
                }
                catch (error) {
                    console.error(`[API] HTTP request failed: ${error.message || ''}`, error);
                    if (retry.attempts <= attempts)
                        throw error;
                    attempts++;
                }
                yield this.sleep(retry.delay);
            }
        });
    }
    getUrl(path) {
        return `${this.url}${path}`;
    }
    parseResponse(axiosResponse) {
        const response = axiosResponse.data;
        if (typeof response.ok === 'boolean') {
            return response;
        }
        return { ok: true, data: response, error: '' };
    }
}
exports.BaseAPI = BaseAPI;
//# sourceMappingURL=api.js.map